/* eslint-disable no-useless-escape */
export default {
	email: /[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/,
	phone: /^[0-9()-+ ]+$/,
	phoneList: /^[A-Z]{2},[0-9]{0,10},[0-9()-+ ]+$/,
	password: /^(?=.*[a-zA-Z])(?=.*[\d]).*$/,
	textOnly: /^[a-zA-Z]*$/,
	numberOnly: /^[\d]*$/,
	confirm: /^confirm$/,
	emailOrPhone: /[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+|^[0-9()-+ ]+$/,
	url: /(https?:\/\/[^\s]+)/,
};